import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useUpdateCompanyByIdMutation } from "../../../../../../API/authApi";
import useUploadFile from "../../../../../../Components/FileUploader/fileUploader-hooks";
import { CustomerCount, IAutocompleteItem, ImageTypes } from "../../../../../../Interfaces/componentTypes";
import { ICreateBusinessForm } from "../../../../../../Interfaces/formValue-interfaces";
import { IEditBusiness } from "./businessDataDialog";
import { customersCount } from "../../../../../../Costants/costants";
import { IUpdateCompanyById } from "../../../../../../Interfaces/request-interfaces";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";
import { useToastify } from "../../../../../../Hooks/hooks";

const useBusinessDataDialogHooks = (props: IEditBusiness) => {
    const { data, onUpdate, onCloseDialog } = props;
    const {t} = useLanguagesHooks();
    const { imageUrl, handleFileInputChange, ImageResponce, imageLoading } = useUploadFile(ImageTypes.LOGO);
    const [update, { data: updatedData, isSuccess: isUpdated, isError: isUpdateError, isLoading }] = useUpdateCompanyByIdMutation();
    const {
        register,
        control,
        formState: { errors },
        setValue,
        getValues,
        watch
    } = useForm<ICreateBusinessForm>({ mode: 'all' });

    const [country, setCountry] = useState<string | null>(data.country);
    const dialogRef = useRef<HTMLDivElement | null>(null);
    const {showToastError,showToastSuccess} = useToastify();
    const [isFormChanged, setIsFormChanged] = useState(false);

    useEffect(() => {
        if (data) {
            setValue('name', data.name);
            setValue('country', data.country);
            setValue('city', data.city);
            setValue('customer_count', customersCount.find((item) => item.id === data.customer_count) as IAutocompleteItem);
        }
    }, [data, setValue]);

    useEffect(()=>{
        imageUrl && ImageResponce && setIsFormChanged(true);
    },[imageUrl,ImageResponce]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            const initialValues = {
                name: data.name,
                country: data.country,
                city: data.city,
                customer_count: customersCount.find((item) => item.id === data.customer_count),
            };

            const hasChanged = Object.keys(initialValues).some(
                (key) => JSON.stringify(value[key as keyof ICreateBusinessForm]) !== JSON.stringify(initialValues[key as keyof typeof initialValues])
            );

            setIsFormChanged(hasChanged);
        });

        return () => subscription.unsubscribe();
    }, [watch, data]);

    useEffect(() => {
        if (isUpdated && updatedData) {
            onCloseDialog();
            onUpdate();
            showToastSuccess(t('Toast.Success.Common'))
        } else if (isUpdateError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [isUpdated, updatedData, isUpdateError]);

    const onEdit = () => {
        const payload: IUpdateCompanyById = {
            id: data.id,
            data: {
                name: getValues().name,
                country: getValues().country,
                city: getValues().city,
                customer_count: (getValues().customer_count as IAutocompleteItem).id as CustomerCount,
                logo: ImageResponce?.src ?? data.logo
            }
        };
        update(payload)
    }

    return {
        register,
        errors,
        control,
        imageUrl,
        country,
        dialogRef,
        isLoading,
        setCountry,
        setValue,
        onEdit,
        handleFileInputChange,
        ImageResponce,
        imageLoading,
        isFormChanged, 
    };
};

export default useBusinessDataDialogHooks;
